import {useMemo} from 'react'
import {PlayerColor} from '@colonist/game-states'
import {UIGamePlayerInfoSectionContentCKProps} from '../../UIGamePlayerInfo'
import {useMechanicValidatorCityImprovements} from '../../../store/selectors/useMechanicValidatorCityImprovements'
import {useMechanicValidatorProgressCards} from '../../../store/selectors/useMechanicValidatorProgressCards'
import {cardEnumsToCardState} from '../../../utils/cards'
import {CardDataController} from '@colonist/game-card-types'

export const usePlayerInfoSectionContentCKProps = (playerColor: PlayerColor) => {
    const progressCardsValidator = useMechanicValidatorProgressCards()
    const cityImprovementsValidator = useMechanicValidatorCityImprovements()

    const progressCardsPlayerHand = progressCardsValidator?.getProgressCardsPlayerValidator(playerColor).progressCards.cards
    if(progressCardsPlayerHand == undefined) return null

    const cityImprovementPlayerState = cityImprovementsValidator?.getPlayerCityImprovementsState(playerColor)
    if(cityImprovementPlayerState == undefined) return null

    return useMemo<UIGamePlayerInfoSectionContentCKProps>(() => {
        const progressCardBacks = CardDataController.getCardBacksForCards(progressCardsPlayerHand)
        const progressCardStateUnordered = cardEnumsToCardState(progressCardBacks)
        return {
            progressCardState: progressCardStateUnordered,
            cityImprovementState: cityImprovementPlayerState,
        }
    }, [progressCardsPlayerHand, cityImprovementPlayerState])
}
